import React, { useState } from 'react'

import { useHistory, useLocation, useParams } from 'react-router-dom'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Button } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  DriveTour,
  LoadingFeedback,
  Page,
} from 'components'
import AiInventoryForm from './components/AiInventoryForm'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'
import {
  buildGeneralInfoPayload,
  buildPurposesPayload,
  fromPersonalDataValue,
} from './components/AiInventoryForm/formMappers'

const AiInventoryEdit = () => {
  const history = useHistory()
  const location = useLocation()
  const snackbar = useSnackbar()
  const { aiInventoryId } = useParams()
  const initialStep = location.state?.initialStep ?? 0
  const [openTour, setOpenTour] = useState(false)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.aiInventory.show,
    aiInventoryId,
    [aiInventoryId],
  )

  const aiInventory = response?.data?.aiInventoryItem || null

  const handleStepSubmit = async (step, data) => {
    try {
      if (step === 0) {
        await service.dponet.aiInventory.update(
          aiInventoryId,
          buildGeneralInfoPayload(data),
        )
      } else if (step === 1) {
        await service.dponet.aiInventory.update(
          aiInventoryId,
          buildPurposesPayload(data),
        )
      }
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao salvar. Tente novamente.',
        variant: 'error',
      })
      throw error
    }
  }

  const handlePersonalDataChange = async (value) => {
    try {
      await service.dponet.aiInventory.updateRiskAnalysis(aiInventoryId, {
        processesPersonalData: fromPersonalDataValue(value),
        riskOptionIds: aiInventory?.riskOptionIds || [],
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao salvar dados pessoais.',
        variant: 'error',
      })
    }
  }

  return (
    <Page title="Editar IA">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading} />
        <ContentHeader title="Editar IA">
          <Button
            id={constants.aiInventory.AI_INVENTORY_FORM_DRIVER_STEP_1}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
          >
            Tutorial
          </Button>
        </ContentHeader>
        {aiInventory && (
          <AiInventoryForm
            mode="edit"
            aiInventory={aiInventory}
            onStepSubmit={handleStepSubmit}
            onPersonalDataChange={handlePersonalDataChange}
            onAiInventoryRefresh={refresh}
            onBack={() => history.push(routes.aiInventory.all)}
            defaultStep={initialStep}
          />
        )}
      </Container>
      <DriveTour
        stepsMatrix={constants.aiInventory.AI_INVENTORY_FORM_DRIVER_STEPS}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default AiInventoryEdit
